export default __webpack_public_path__ + "static/media/05en.7ceed27e.mp3";